const accordions = document.querySelectorAll(".accordion-section");

accordions.forEach((accordion) => {
    const accordionItems = accordion.querySelectorAll(".accordion-item");

    accordionItems.forEach((item) => {
        const button = item.querySelector(".question");
        const wrapper = item.querySelector(".text-wrapper");

        button?.addEventListener("click", () => {
            const open = item.classList.toggle("open");
            wrapper?.classList.toggle("open", open);
            button.setAttribute("aria-expanded", open.toString());
        });
    });
});
